import type { EventSegment, TripSegment } from '../../../../../../../widgets/trip-itinerary/models';

export const getTotalTravelDuration = (segments: (TripSegment | EventSegment)[]) =>
  segments.reduce(
    (acc, segment) =>
      segment?.duration && !Number.isNaN(segment.duration) ? acc + segment.duration : acc,
    0,
  );
